/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';
import { t } from 'utils/translates';

const Desc = () => (
  <div className="navbar navbar-default">
    <div className="container-fluid">
      <h1 className="h5 navbar-text">
        <i aria-hidden="true" className="fa fa-handshake-o" />{' '}
        {t('Партнерская программа')}
      </h1>
      <p className="navbar-text navbar-right m-r-10">
        <PopUpLink
          className="text-muted pull-right"
          hashName="fagContent"
          hashParams={{ id: 'referral_program_info' }}
        >
          <i className="fa fa-question-circle-o" /> {t('Условия')}
        </PopUpLink>
      </p>
    </div>
  </div>
);

export default Desc;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ReferralProgram/ReferralMyStat/Desc/Desc.js